import React, {Component} from 'react';

import TopTwentyForm from './TopTwentyForm'
import TopTwentyView from './TopTwentyView'
import LoadingBar from "../components/Modules/LoadingBar";

import PropTypes from 'prop-types';

class TopTwenty extends Component {
  static propTypes = {
    canEdit:        PropTypes.bool,
    loading:        PropTypes.bool,
    onSaveSchedule: PropTypes.func.isRequired,
    top_twenty:    PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  render() {
    if (this.props.loading) return <LoadingBar/>;

    if ( ! this.props.canEdit)
      return <TopTwentyView top_twenty={ this.props.top_twenty } />;

    if ( ! this.state.editing )
      return <div>
        <TopTwentyView top_twenty={ this.props.top_twenty } />
        { this.props.canEdit &&
            <a style={{float:'right', color: 'blue'}}
               onClick={() => this.setState({editing: true })}>Edit</a>
        }
      </div>
    else
      return <TopTwentyForm
        data={ this.props.top_twenty.data }
        onSubmit={ this.props.onSaveSchedule }
        onCancel={ () => this.setState({ editing: false }) }
      />

  }

}


export default TopTwenty;



/** WEBPACK FOOTER **
 ** ./src/scheduleform/TopTwenty.jsx
 **/